import * as React from "react";

const UserIcon: React.FC<React.SVGProps<SVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    fill="none"
    viewBox="0 0 36 36"
  >
    <path
      fill="#000"
      d="M18 5.625c-4.337 0-7.875 3.538-7.875 7.875a7.9 7.9 0 0 0 3.48 6.54C9.594 21.76 6.75 25.743 6.75 30.375H9c0-4.984 4.016-9 9-9s9 4.016 9 9h2.25c0-4.632-2.843-8.613-6.856-10.336a7.9 7.9 0 0 0 3.481-6.539c0-4.337-3.538-7.875-7.875-7.875m0 2.25a5.61 5.61 0 0 1 5.625 5.625A5.61 5.61 0 0 1 18 19.125a5.61 5.61 0 0 1-5.625-5.625A5.61 5.61 0 0 1 18 7.875"
    ></path>
  </svg>
);

export default React.memo(UserIcon);
